
/* eslint-disable */
// @ts-nocheck
// @ts-ignore

import * as srvoption from './srvoption.proto';
import * as common from './common.proto';
import * as login_srv from './lu\login_srv\login_srv.proto';


export const enum UserGender {
  UserGenderUnknown = 0,
  UserGenderMale = 1,
  UserGenderFemale = 2,
  UserGenderSecrecy = 3,
}

export const enum UserStatus {
  UserStatusUnknown = 0,
  UserStatusCreating = 1,
  UserStatusNormal = 2,
  UserStatusCanceling = 3,
  UserStatusCanceled = 4,
  UserStatusForbidden = 5,
}

export const enum UserType {
  UserTypeUnknown = 0,
  UserTypeNature = 1,
  UserTypeBot = 2,
  UserTypeVirtualOffical = 3,
  UserTypeChannelExclusive = 4,
}

export const enum UserChannel {
  UserChannelUnknown = 0,
  UserChannelAPP = 1,
  UserChannelSystem = 2,
  UserChannelEmbedding = 3,
}

export interface UserInfoAttribute {
  /** 用户类型 */
  userType: UserType;
  /** 用户创建渠道 */
  userChannel: UserChannel;
  /** 渠道扩展信息 */
  channelExtInfo: Record<string, string>;
}

export interface UserInfoBaseStorage {
  /** 用户ID */
  uid: string;
  /** 创建时间 */
  createdAt: string;
  /** 修改时间 */
  updatedAt: string;
  /** 用户属性 */
  userAttribute: UserInfoAttribute;
  /** 用户状态 */
  userStatus: UserStatus;
  /** 用户账号信息 */
  userAccounts: UserInfoAccountStorage;
  /** 用户昵称 */
  nickname: string;
  /** 用户头像 */
  avatar: string;
  /** 性别 */
  gender: UserGender;
  /** 注销时间 */
  cancelAt: string;
}

export interface UserLUUid2UidStorage {
  /** 用户uid */
  uid: string;
  /** 用户状态 */
  status: UserStatus;
}

export interface UserExtId2UidStorage {
  /** 用户uid */
  uid: string;
  /** 用户状态 */
  status: UserStatus;
}

export interface UserNicknameStorage {
  /** 用户uid */
  uid: string;
  /** 时间戳 */
  ts: string;
}

export interface UserInfoAccountStorage {
  /** 对应的统一账号ID, key:lu_uid */
  luUidMap: Record<string, UserLUAccountInfo>;
  /** 对应的外部账号ID, key:ext_id */
  extIdMap: Record<string, UserExternalAccountInfo>;
}

export interface UserLUAccountInfo {
  /** 用户ID */
  luUid: string;
  /** 登录类型 */
  loginType: any;
  /** openid */
  openId: string;
  /** 昵称 */
  nickName: string;
}

export interface UserExternalAccountInfo {
  /** 外部ID */
  extId: string;
  /** 扩展信息 */
  extInfo: any;
}

export interface UserRegInfo {
  /** 端信息 */
  clientInfo: UserRegClientInfo;
  /** 邀请码 */
  inviteCode: string;
}

export interface UserRegClientInfo {
  /** 平台 */
  platform: common.Platform;
  /** 操作系统 */
  sysId: common.SystemType;
  /** 渠道名称：  WXOfficial、WXMiniApp、CHShanxian */
  channelType: string;
  /** 名称, 公众号名称/小程序名称 */
  channelName: string;
}

export const enum UserOperType {
  UserOperTypeUnknown = 0,
  UserOperCreate = 1,
  UserOperUpdate = 2,
}

/** 用户消息 */
export interface UserOperMsg {
  /** 用户uid */
  uid: string;
  /** 操作 */
  oper: UserOperType;
  /** 时间戳 */
  ts: string;
  /** 消息ID */
  msgID: string;
  /** 用于给user_daemon传递参数 */
  params: Record<string, string>;
}

export interface UserInfoBase {
  /** 用户ID */
  uid: string;
  /** 用户昵称 */
  nickname: string;
  /** 用户头像 */
  avatar: string;
  /** 性别 */
  gender: UserGender;
  /** 用户类型 */
  userType: UserType;
  /** 手机号 */
  num: string;
  /** 用户状态 */
  userStatus: UserStatus;
}

export interface UserInfoAccount {
  /** 手机号, 手机号登录时使用的手机号 */
  phone: string;
}

export interface UserInfoCancel {
  /** 用户注销的时间 */
  cancelAt: string;
}

export interface UserInviteConfig {
  /** 是否显示邀请码 */
  inviteEnable: boolean;
  /** 邀请码是否必要 */
  inviteRequire: boolean;
  /** 邀请码文案 */
  inviteText: string;
}

export interface BanLoginInfo {
  /** 是否禁止登录 */
  banLogin: boolean;
  /** 用来弹窗展示 */
  banTips: string;
}

export interface UserInfoLULoginCallback {
  /** 业务用户ID */
  uid: string;
  /** 邀请码配置 */
  inviteConfig: UserInviteConfig;
  /** 腾讯云IM的UserSig, uid非0时会返回 */
  IMUserSig: string;
  /** 是否绑定了手机号 */
  bindPhone: boolean;
  /** 封禁登录信息 */
  banLogin: BanLoginInfo;
}

export interface LUAccountSession {
  /** 用户ID */
  luUid: string;
  /** 登录类型 */
  loginType: any;
  /** LU票据 */
  luToken: string;
}

export interface LUOriginUserInfo {
  /** 昵称 */
  nickname: string;
}

export interface UserOauth {
  a: string;
  b: string;
  oauthMap: Record<string, UserOauth>;
}
